export default __webpack_public_path__ + "static/media/Offgrades.28f27c8a.jpg";